// extracted by mini-css-extract-plugin
module.exports = {"main":"ImageTextButton-module--main--2Bgzm","image":"ImageTextButton-module--image--BadKu","name":"ImageTextButton-module--name--2-L0t"};